module.exports = __webpack_public_path__ + "images/finance-courses-offer-banner-mobile.jpg";